const Catering = () => (
    <main>
    <h1>Catering</h1>
    <p>Bring the kooky to your event! We cater weddings, birthdays, and office parties with customizable cookie platters.</p>
  </main>
);

export default Catering;